import { Injectable } from '@angular/core';
import { LiteratureDataService } from '@literature/services/literature-data.service';
import { ApiUrls, AppStateService } from '@services/app-state.service';
import { MailFormValues } from '@types';

@Injectable({
  providedIn: 'root',
})
export class LiteratureYourCartMailService {
  constructor(private literatureDataService: LiteratureDataService) {}

  setMailFormValue(formData: MailFormValues): void {
    this.literatureDataService.setMailDetails(formData);
  }
}
